import { gfmTableFromMarkdown, gfmTableToMarkdown } from "mdast-util-gfm-table";
import { gfmTable } from "micromark-extension-gfm-table";
import { type Processor } from "unified";

export function remarkGfmTable(this: Processor) {
	const data = this.data();

	const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
	const fromMarkdownExtensions =
		data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
	const toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);

	micromarkExtensions.push(gfmTable());
	fromMarkdownExtensions.push(gfmTableFromMarkdown());
	toMarkdownExtensions.push(gfmTableToMarkdown());
}
